<div
  class="scroll vi-primary vi-hue-1 print-content no-print-flexbox truespeed-content internal"
  #pdfPage
  *ngIf="!loading"
>
  <div layout="column" class="page">
    <div class="page-break"></div>

    <div class="report-header">
      <img src="{{ logoUrl }}" class="truespeed-logo" />
      <h2 class="truespeed-title">{{ reportTitle }}</h2>
    </div>

    <hr />
    <div class="margin-10-left">
      <div style="margin-top: 10px; line-height: 1.6">
        <div class="header-style">
          <div class="header-class">Test Name</div>
          <div class="value-font">
            {{ requestInfo?.testName }}
          </div>
        </div>
        <div class="header-style">
          <div class="header-class">Start Date</div>
          <div class="value-font">{{ startDate }}</div>
        </div>
        <div class="header-style">
          <div class="header-class">End Date</div>
          <div class="value-font">{{ stopDate }}</div>
        </div>
        <div class="header-style">
          <div class="header-class">Duration</div>
          <div class="value-font">{{ duration }}</div>
        </div>
        <div class="header-style" *ngIf="overallConfiguration">
          <div class="header-class">Test Points</div>
          <div class="value-font">
            {{ overallConfiguration.agent.primary.id }}
          </div>
        </div>
        <div
          class="header-style"
          *ngIf="
            overallConfiguration &&
            overallConfiguration.agent.secondary &&
            overallConfiguration.agent.secondary.length > 0
          "
        >
          <div class="header-class"></div>
          <div
            class="value-font"
            *ngIf="
              overallConfiguration &&
              overallConfiguration.agent.secondary &&
              overallConfiguration.agent.secondary.length > 0
            "
          >
            {{ overallConfiguration.agent.secondary[0].id }}
          </div>
        </div>
      </div>
      <div style="margin-top: 10px; line-height: 1.6">
        <div class="header-style" *ngIf="requestInfo.mode === 'CLIENT-TO-MA' && requestInfo.dmzUrl">
          <div class="header-class">DMZ Test URL</div>
          <div class="value-font">
            {{ requestInfo.dmzUrl }}
          </div>
        </div>
        <div
          class="header-style"
          *ngIf="
            requestInfo.mode === 'CLIENT-TO-MA' && requestInfo.vtaTsUrl && overallConfiguration
          "
        >
          <div class="header-class">{{ getAgentURLLabel() }}</div>
          <div class="value-font">
            {{ requestInfo.vtaTsUrl }}
          </div>
        </div>
      </div>
      <div
        *ngIf="
          requestInfo?.customerInfo?.name ||
          requestInfo?.customerInfo?.contact ||
          requestInfo?.customerInfo?.phone ||
          requestInfo?.customerInfo?.email
        "
      >
        <div class="reports-customer-info">
          <div class="info-title">Customer</div>
          <div class="info-container">
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.name">
              <div class="sec-header">Name</div>
              <div class="sec-value">{{ requestInfo.customerInfo.name }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.contact">
              <div class="sec-header">Contact</div>
              <div class="sec-value">{{ requestInfo.customerInfo.contact }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.email">
              <div class="sec-header">Email</div>
              <div class="sec-value">{{ requestInfo.customerInfo.email }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.phone">
              <div class="sec-header">Phone</div>
              <div class="sec-value">{{ requestInfo.customerInfo.phone }}</div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="
        requestInfo &&
          (requestInfo?.['techInfo']?.name ||
          requestInfo?.['techInfo']?.id)
        "
      >
        <div class="reports-customer-info">
          <div class="info-title">Technician</div>
          <div class="info-container">
            <div
              class="details-sec"
              *ngIf="
            requestInfo && requestInfo?.['techInfo']?.name
            "
            >
              <div class="sec-header">Name</div>
              <div class="sec-value">
                {{ requestInfo?.['techInfo']?.name }}
              </div>
            </div>
            <div
              class="details-sec"
              *ngIf="
              overallConfiguration &&
              requestInfo?.['techInfo']?.id
            "
            >
              <div class="sec-header">ID</div>
              <div class="sec-value">
                {{ requestInfo?.['techInfo']?.id }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 30px" *ngIf="requestInfo && requestInfo?.comments">
        <div class="header-style">
          <div class="header-class">Comments</div>
          <div class="value-font">
            {{ requestInfo.comments }}
          </div>
        </div>
      </div>
      <div style="margin-top: 30px">
        <div class="header-style">
          <div class="header-class">Summary</div>
          <div class="pass-color" *ngIf="overallResult === 'Pass'">TEST PASSED</div>
          <div class="fail-color" *ngIf="overallResult === 'Fail'">
            TEST FAILED
            <div class="fail-color-3" *ngIf="errorMessage">{{ errorMessage }}</div>
          </div>

          <div class="unknown-color" *ngIf="overallResult === 'Inconclusive'">
            TEST INCONCLUSIVE
          </div>
          <div class="unknown-color" *ngIf="overallResult === 'Unknown'">
            TEST {{ controllerStatus }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div layout="column" class="page" *ngIf="spAngReport">
    <div class="page-break"></div>
    <div class="header-font-1">
      <div class="alignment-font">
        <img class="icon" [attr.src]="'images/SPTIcon.svg'" />
        <span class="margin-10-left">Service Performance Test Results</span>
      </div>
      <button
        mat-button
        *ngIf="!resultsNotAvailable && spAngReport && !trendingInProgress && !trendingComplete"
        class="btn btn-blue"
        style="margin-right: 40px"
        (click)="trendCharts()"
      >
        Show Trend Charts
      </button>

      <div
        class="getting-trending-container vi-primary-font-color no-print"
        *ngIf="trendingInProgress"
      >
        <i class="fa fa-circle-o-notch fa-spin"> </i>
        <div class="trending-msg">{{ trendingMsg }}</div>
        <div class="trending-progress-bar">
          <md-progress-linear
            md-mode="determinate"
            class="trending-progress"
            value="{{ trendingPercent }}"
          ></md-progress-linear>
        </div>
      </div>
    </div>
    <hr />
    <ng-container *ngIf="!showRtdOptions">
      <ng-container *ngFor="let row of sortSpAngReport">
        <hr
          class="line-color"
          *ngIf="row['originator'] === 'engine-a' || row['originator'] === 'ENGINE_A'"
        />
        <div
          class="stream-font"
          *ngIf="row['originator'] === 'engine-a' || row['originator'] === 'ENGINE_A'"
        >
          {{ row['stream-name'] }}
        </div>
        <div class="verdict-display">
          <div *ngIf="row['verdict'] === 'pass'" class="pass-color-1">PASSED</div>
          <div *ngIf="row['verdict'] === 'fail'" class="fail-color-1">FAILED</div>
          <!-- <div style="font-size: 14px; font-weight: bold; margin-left: 20px; margin-right: 1px;" *ngIf="row['originator'] === 'engine-a'">
          {{ row['stream-name'] }}
        </div> -->
          <div *ngIf="row['verdict'] === 'fail'" class="fail-color-2">
            {{ row['verdict-reason'] }}
          </div>
          <div *ngIf="row['verdict'] === 'pass'" class="pass-color-2">
            {{ row['verdict-reason'] }}
          </div>
          <div
            class="direction"
            *ngIf="
              testMode !== 'loopback' &&
              (row['originator'] === 'engine-a' || row['originator'] === 'ENGINE_A')
            "
          >
            A <i class="mdi mdi-arrow-right-bold onewayAColor"></i> B
          </div>
          <div
            class="direction"
            *ngIf="
              testMode !== 'loopback' &&
              (row['originator'] === 'engine-b' || row['originator'] === 'ENGINE_B')
            "
          >
            B <i class="mdi mdi-arrow-right-bold onewayBColor"></i> A
          </div>
        </div>
        <div class="field-style">
          <div class="width-font">
            <div *ngIf="row['frame-size-average']" class="alignment-font">
              <div class="bold-font">Frame</div>
              <div>: {{ row['frame-size-average'] }}</div>
            </div>
            <div *ngIf="row['target-ir']" class="alignment-font">
              <div class="bold-font" *ngIf="streamRateValue === 'l1-mbps'">CIR (ULR)</div>
              <div class="bold-font" *ngIf="streamRateValue === 'l2-mbps'">CIR (IR)</div>
              <div>: {{ row['target-ir'] }} Mbps</div>
            </div>
            <div *ngIf="row['transmitted-ir']" class="alignment-font">
              <div class="bold-font">Tx IR</div>
              <div>: {{ row['transmitted-ir'] }} Mbps</div>
            </div>
            <div *ngIf="row['transmitted-ulr']" class="alignment-font">
              <div class="bold-font">Tx ULR</div>
              <div>:{{ row['transmitted-ulr'] }} Mbps</div>
            </div>
            <div *ngIf="row['network-ulr']" class="alignment-font">
              <div class="bold-font">Network ULR</div>
              <div>: {{ row['network-ulr'] }} Mbps</div>
            </div>
            <div
              *ngIf="streamRateConvention !== 'L1 Mbps (ULR)' && row['ir-avg']"
              class="alignment-font"
            >
              <div class="bold-font">IR Avg</div>
              <div>: {{ row['ir-avg'] }} Mbps</div>
            </div>
          </div>
          <table class="sp-table" style="width: 80%">
            <tr>
              <th
                class="header-top-color"
                *ngIf="streamRateConvention === 'L1 Mbps (ULR)' || row['network-ulr']"
              >
                L1 Mbps (ULR)
              </th>
              <th
                class="header-top-color"
                *ngIf="
                  streamRateConvention !== 'L1 Mbps (ULR)' &&
                  (row['ir-avg'] || row['ir-min'] || row['ir-max'])
                "
              >
                L2 Mbps (IR)
              </th>
              <th
                *ngIf="
                  row['flr-verdict'] &&
                  (row['frame-loss-ratio'] !== 'NaN' ||
                    row['frame-loss-ratio'] !== 'undefined' ||
                    row['peak-frame-loss-ratio'] ||
                    row['frame-loss-sla'])
                "
                [ngStyle]="
                  row['flr-verdict'] === 'fail'
                    ? { background: '#fae5ea' }
                    : { background: '#eaf5f6' }
                "
              >
                Loss
              </th>
              <ng-container *ngIf="testMode === 'loopback' && layerToTest === 'L4'">
                <th
                  *ngIf="
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FD
                </th>
                <th
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FDV
                </th>
              </ng-container>
              <ng-container *ngIf="layerToTest !== 'L4'">
                <th
                  *ngIf="
                    testMode === 'loopback' &&
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FD
                </th>
                <th
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FDV
                </th>
              </ng-container>

              <th
                class="th-background-color"
                *ngIf="
                  row['tx-frame-count'] ||
                  row['rx-frame-count'] ||
                  row['frame-loss-count'] ||
                  row['oos-count']
                "
              >
                Counts
              </th>
            </tr>
            <tr>
              <td *ngIf="streamRateConvention === 'L1 Mbps (ULR)' && !row['network-ulr']">
                <div class="bold-font" *ngIf="row['transmitted-ulr']">
                  Tx: {{ row['transmitted-ulr'] }}
                  <span class="normal-font">Mbps</span>
                </div>
                <div class="bold-font">
                  Rx: {{ row['ir-avg'] }}
                  <span class="normal-font">Mbps</span>
                </div>
              </td>
              <td *ngIf="row['network-ulr']">
                <div class="bold-font" *ngIf="row['transmitted-ulr']">
                  Tx: {{ row['transmitted-ulr'] }}
                  <span class="normal-font">Mbps</span>
                </div>
                <div class="bold-font">
                  Rx: {{ row['network-ulr'] }}
                  <span class="normal-font">Mbps</span>
                </div>
              </td>
              <td
                *ngIf="
                  streamRateConvention !== 'L1 Mbps (ULR)' &&
                  (row['ir-avg'] || row['ir-min'] || row['ir-max'])
                "
                class="header-top-color"
              >
                <div class="bold-font" *ngIf="row['transmitted-ir']">
                  Tx: {{ row['transmitted-ir'] }} <span class="normal-font">Mbps</span>
                </div>
                <div class="bold-font" *ngIf="row['ir-avg']">
                  Rx Avg: {{ row['ir-avg'] }} <span class="normal-font">Mbps</span>
                </div>
                <div class="margin-10">
                  <div *ngIf="row['ir-min']">Rx Min: {{ row['ir-min'] }} Mbps</div>
                  <div *ngIf="row['ir-max']">Rx Max: {{ row['ir-max'] }} Mbps</div>
                </div>
              </td>

              <td
                *ngIf="
                  row['flr-verdict'] &&
                  (row['frame-loss-ratio'] !== 'NaN' ||
                    row['frame-loss-ratio'] !== 'undefined' ||
                    row['peak-frame-loss-ratio'] ||
                    row['frame-loss-sla'])
                "
                [ngStyle]="
                  row['flr-verdict'] === 'fail'
                    ? { background: '#fae5ea' }
                    : { background: '#eaf5f6' }
                "
              >
                <div
                  class="bold-font"
                  *ngIf="
                    showRtdOptions &&
                    (row['frame-loss-ratio'] !== 'NaN' || row['frame-loss-ratio'] !== 'undefined')
                  "
                  [ngClass]="{
                    'kpi-bad': row['flr-verdict'] === 'fail'
                  }"
                >
                  Avg: {{ formatFLR(row['frame-loss-ratio']) }} <span class="normal-font">%</span>
                </div>
                <div
                  class="bold-font"
                  *ngIf="
                    !showRtdOptions &&
                    versionValue === 'v1' &&
                    (row['frame-loss-ratio'] !== 'NaN' || row['frame-loss-ratio'] !== 'undefined')
                  "
                  [ngClass]="{
                    'kpi-bad': row['flr-verdict'] === 'fail'
                  }"
                >
                  Avg: {{ formatFLR(row['frame-loss-ratio']) }}
                  <span class="normal-font">%</span>
                </div>
                <div
                  class="bold-font"
                  *ngIf="
                    !showRtdOptions &&
                    versionValue === 'v2' &&
                    (row['frame-loss-ratio'] !== 'NaN' || row['frame-loss-ratio'] !== 'undefined')
                  "
                  [ngClass]="{
                    'kpi-bad': row['flr-verdict'] === 'fail'
                  }"
                >
                  Avg: {{ formatFLR(row['frame-loss-ratio']) }}
                  <span class="normal-font">%</span>
                </div>
                <div class="margin-10">
                  <div *ngIf="row['peak-frame-loss-ratio']">
                    Peak: {{ row['peak-frame-loss-ratio'] }} %
                  </div>
                  <div *ngIf="row['frame-loss-sla']">SLA: {{ row['frame-loss-sla'] }} %</div>
                </div>
              </td>
              <ng-container *ngIf="testMode === 'loopback' && layerToTest === 'L4'">
                <td
                  *ngIf="
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fd-avg']"
                    [ngClass]="{
                      'kpi-good': row['fd-verdict'] === 'pass',
                      'kpi-bad': row['fd-verdict'] === 'fail'
                    }"
                  >
                    Avg: {{ row['fd-avg'] }}
                    <span *ngIf="row['fd-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10">
                    <div *ngIf="row['fd-min']">
                      Min: {{ row['fd-min'] }}
                      <span *ngIf="row['fd-min'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-max']">
                      Max: {{ row['fd-max'] }}
                      <span *ngIf="row['fd-max'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-sla']">
                      SLA: {{ row['fd-sla'] }}
                      <span *ngIf="row['fd-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
                <td
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fdv-avg']"
                    [ngClass]="{
                      'kpi-good':
                        row['fdv-verdict'] === 'pass' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10',
                      'kpi-bad':
                        row['fdv-verdict'] === 'fail' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10'
                    }"
                  >
                    Avg: {{ row['fdv-avg'] }}
                    <span *ngIf="row['fdv-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10" *ngIf="row['fdv-max']">
                    <div
                      [ngClass]="{
                        'kpi-good':
                          row['fdv-verdict'] === 'pass' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10',
                        'kpi-bad':
                          row['fdv-verdict'] === 'fail' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10'
                      }"
                    >
                      Max: {{ row['fdv-max'] }}
                      <span *ngIf="row['fdv-max'] !== 'n/a'">ms</span>
                    </div>
                    <div *ngIf="row['fdv-sla']">
                      SLA: {{ row['fdv-sla'] }}
                      <span *ngIf="row['fdv-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container *ngIf="layerToTest !== 'L4'">
                <td
                  *ngIf="
                    testMode === 'loopback' &&
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fd-avg']"
                    [ngClass]="{
                      'kpi-good': row['fd-verdict'] === 'pass',
                      'kpi-bad': row['fd-verdict'] === 'fail'
                    }"
                  >
                    Avg: {{ row['fd-avg'] }}
                    <span *ngIf="row['fd-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10">
                    <div *ngIf="row['fd-min']">
                      Min: {{ row['fd-min'] }}
                      <span *ngIf="row['fd-min'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-max']">
                      Max: {{ row['fd-max'] }}
                      <span *ngIf="row['fd-max'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-sla']">
                      SLA: {{ row['fd-sla'] }}
                      <span *ngIf="row['fd-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
                <td
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fdv-avg']"
                    [ngClass]="{
                      'kpi-good':
                        row['fdv-verdict'] === 'pass' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10',
                      'kpi-bad':
                        row['fdv-verdict'] === 'fail' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10'
                    }"
                  >
                    Avg: {{ row['fdv-avg'] }}
                    <span *ngIf="row['fdv-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10" *ngIf="row['fdv-max']">
                    <div
                      [ngClass]="{
                        'kpi-good':
                          row['fdv-verdict'] === 'pass' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10',
                        'kpi-bad':
                          row['fdv-verdict'] === 'fail' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10'
                      }"
                    >
                      Max: {{ row['fdv-max'] }}
                      <span *ngIf="row['fdv-max'] !== 'n/a'">ms</span>
                    </div>
                    <div *ngIf="row['fdv-sla']">
                      SLA: {{ row['fdv-sla'] }}
                      <span *ngIf="row['fdv-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
              </ng-container>

              <td
                class="th-background-color"
                *ngIf="
                  row['tx-frame-count'] ||
                  row['rx-frame-count'] ||
                  row['frame-loss-count'] ||
                  row['oos-count']
                "
              >
                <div *ngIf="row['tx-frame-count']">Tx: {{ row['tx-frame-count'] }}</div>
                <div *ngIf="row['rx-frame-count']">Rx: {{ row['rx-frame-count'] }}</div>
                <div *ngIf="row['frame-loss-count']">Lost: {{ row['frame-loss-count'] }}</div>
                <div *ngIf="row['oos-count']">OOS: {{ row['oos-count'] }}</div>
              </td>
            </tr>
          </table>
        </div>
        <div *ngIf="trendChartsData" class="sct-metric-container">
          <div *ngFor="let series of chartSeriesConfig" class="sct-metrics">
            <ng-container *ngFor="let stream of performanceData" class="field-style">
              <div *ngIf="row['stream-name'] === stream.name" class="sct-metric-section">
                <div *ngIf="row['originator'] === 'engine-a' || row['originator'] === 'ENGINE_A'">
                  <nrwl-stream-metrics-chart
                    [seriesOptions]="series"
                    [chartData]="stream.engineAData.dataSource"
                    [stepTime]="durationForStream"
                    [streamConfig]="stream.streamConfig"
                    [showCurrentValue]="false"
                  ></nrwl-stream-metrics-chart>
                </div>
                <div *ngIf="row['originator'] === 'engine-b' || row['originator'] === 'ENGINE_B'">
                  <nrwl-stream-metrics-chart
                    [seriesOptions]="series"
                    [chartData]="stream.engineBData.dataSource"
                    [stepTime]="durationForStream"
                    [streamConfig]="stream.streamConfig"
                    [showCurrentValue]="false"
                  ></nrwl-stream-metrics-chart>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="showRtdOptions">
      <ng-container *ngFor="let row of uniqueSpArray">
        <hr class="line-color" />
        <div class="verdict-display">
          <div *ngIf="row['verdict'] === 'pass'" class="pass-color-1">PASSED</div>
          <div *ngIf="row['verdict'] === 'fail'" class="fail-color-1">FAILED</div>
          <div class="stream-name">
            {{ row['stream-name'] }}
          </div>
          <div *ngIf="row['verdict'] === 'fail'" class="fail-color-2">
            {{ row['verdict-reason'] }}
          </div>
          <div *ngIf="row['verdict'] === 'pass'" class="pass-color-2">
            {{ row['verdict-reason'] }}
          </div>
        </div>
        <div class="field-style">
          <div class="width-font">
            <div *ngIf="row['frame-size-average']" class="alignment-font">
              <div class="bold-font">Frame</div>
              <div>: {{ row['frame-size-average'] }}</div>
            </div>
            <div *ngIf="row['target-ir']" class="alignment-font">
              <div class="bold-font" *ngIf="streamRateValue === 'l1-mbps'">CIR (ULR)</div>
              <div class="bold-font" *ngIf="streamRateValue === 'l2-mbps'">CIR (IR)</div>
              <div>: {{ row['target-ir'] }} mbps</div>
            </div>
            <div *ngIf="row['transmitted-ir']" class="alignment-font">
              <div class="bold-font">Tx IR</div>
              <div>: {{ row['transmitted-ir'] }} Mbps</div>
            </div>
            <div *ngIf="row['transmitted-ulr']" class="alignment-font">
              <div class="bold-font">Tx ULR</div>
              <div>:{{ row['transmitted-ulr'] }} Mbps</div>
            </div>
            <div *ngIf="row['network-ulr']" class="alignment-font">
              <div class="bold-font">Network ULR</div>
              <div>: {{ row['network-ulr'] }} Mbps</div>
            </div>
          </div>
          <table class="sp-table" style="width: 80%">
            <tr>
              <th
                class="header-top-color"
                *ngIf="streamRateConvention === 'L1 Mbps (ULR)' || row['network-ulr']"
              >
                L1 Mbps (ULR)
              </th>
              <th
                class="header-top-color"
                *ngIf="
                  streamRateConvention !== 'L1 Mbps (ULR)' &&
                  (row['ir-avg'] || row['ir-min'] || row['ir-max'])
                "
              >
                L2 Mbps (IR)
              </th>
              <th
                *ngIf="
                  row['flr-verdict'] &&
                  (row['frame-loss-ratio'] !== 'NaN' ||
                    row['frame-loss-ratio'] !== 'undefined' ||
                    row['peak-frame-loss-ratio'] ||
                    row['frame-loss-sla'])
                "
                [ngStyle]="
                  row['flr-verdict'] === 'fail'
                    ? { background: '#fae5ea' }
                    : { background: '#eaf5f6' }
                "
              >
                Loss
              </th>
              <ng-container *ngIf="testMode === 'loopback' && layerToTest === 'L4'">
                <th
                  *ngIf="
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FD
                </th>
                <th
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FDV
                </th>
              </ng-container>
              <ng-container *ngIf="layerToTest !== 'L4'">
                <th
                  *ngIf="
                    testMode === 'loopback' &&
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FD
                </th>
                <th
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FDV
                </th>
              </ng-container>

              <th
                class="th-background-color"
                *ngIf="
                  row['tx-frame-count'] ||
                  row['rx-frame-count'] ||
                  row['frame-loss-count'] ||
                  row['oos-count']
                "
              >
                Counts
              </th>
            </tr>
            <tr>
              <td *ngIf="streamRateConvention === 'L1 Mbps (ULR)' && !row['network-ulr']">
                <div class="bold-font" *ngIf="row['transmitted-ulr']">
                  Tx: {{ row['transmitted-ulr'] }}
                  <span class="normal-font">Mbps</span>
                </div>
                <div class="bold-font">
                  Rx: {{ row['ir-avg'] }}
                  <span class="normal-font">Mbps</span>
                </div>
              </td>
              <td *ngIf="streamRateConvention !== 'L1 Mbps (ULR)' && row['network-ulr']">
                <div class="bold-font" *ngIf="row['transmitted-ulr']">
                  Tx: {{ row['transmitted-ulr'] }}
                  <span class="normal-font">Mbps</span>
                </div>
                <div class="bold-font">
                  Rx: {{ row['network-ulr'] }}
                  <span class="normal-font">Mbps</span>
                </div>
              </td>
              <td
                *ngIf="
                  streamRateConvention !== 'L1 Mbps (ULR)' &&
                  (row['ir-avg'] || row['ir-min'] || row['ir-max'])
                "
                class="header-top-color"
              >
                <div class="bold-font" *ngIf="row['transmitted-ir']">
                  Tx: {{ row['transmitted-ir'] }} <span class="normal-font">Mbps</span>
                </div>
                <div class="bold-font" *ngIf="row['ir-avg']">
                  Rx Avg: {{ row['ir-avg'] }} <span class="normal-font">Mbps</span>
                </div>
                <div class="margin-10">
                  <div *ngIf="row['ir-min']">Rx Min: {{ row['ir-min'] }} Mbps</div>
                  <div *ngIf="row['ir-max']">Rx Max: {{ row['ir-max'] }} Mbps</div>
                </div>
              </td>

              <td
                *ngIf="
                  row['flr-verdict'] &&
                  (row['frame-loss-ratio'] !== 'NaN' ||
                    row['frame-loss-ratio'] !== 'undefined' ||
                    row['peak-frame-loss-ratio'] ||
                    row['frame-loss-sla'])
                "
                [ngStyle]="
                  row['flr-verdict'] === 'fail'
                    ? { background: '#fae5ea' }
                    : { background: '#eaf5f6' }
                "
              >
                <div
                  class="bold-font"
                  *ngIf="
                    row['frame-loss-ratio'] !== 'NaN' || row['frame-loss-ratio'] !== 'undefined'
                  "
                  [ngClass]="{
                    'kpi-bad': row['flr-verdict'] === 'fail'
                  }"
                >
                  Avg: {{ formatFLR(row['frame-loss-ratio']) }} <span class="normal-font">%</span>
                </div>
                <div class="margin-10">
                  <div *ngIf="row['peak-frame-loss-ratio']">
                    Peak: {{ row['peak-frame-loss-ratio'] }} %
                  </div>
                  <div *ngIf="row['frame-loss-sla']">SLA: {{ row['frame-loss-sla'] }} %</div>
                </div>
              </td>
              <ng-container *ngIf="testMode === 'loopback' && layerToTest === 'L4'">
                <td
                  *ngIf="
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fd-avg']"
                    [ngClass]="{
                      'kpi-good': row['fd-verdict'] === 'pass',
                      'kpi-bad': row['fd-verdict'] === 'fail'
                    }"
                  >
                    Avg: {{ row['fd-avg'] }}
                    <span *ngIf="row['fd-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10">
                    <div *ngIf="row['fd-min']">
                      Min: {{ row['fd-min'] }} <span *ngIf="row['fd-min'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-max']">
                      Max: {{ row['fd-max'] }} <span *ngIf="row['fd-max'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-sla']">
                      SLA: {{ row['fd-sla'] }} <span *ngIf="row['fd-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
                <td
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fdv-avg']"
                    [ngClass]="{
                      'kpi-good':
                        row['fdv-verdict'] === 'pass' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10',
                      'kpi-bad':
                        row['fdv-verdict'] === 'fail' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10'
                    }"
                  >
                    Avg: {{ row['fdv-avg'] }}
                    <span *ngIf="row['fdv-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10" *ngIf="row['fdv-max']">
                    <div
                      [ngClass]="{
                        'kpi-good':
                          row['fdv-verdict'] === 'pass' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10',
                        'kpi-bad':
                          row['fdv-verdict'] === 'fail' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10'
                      }"
                    >
                      Max: {{ row['fdv-max'] }}
                      <span *ngIf="row['fdv-max'] !== 'n/a'">ms</span>
                    </div>
                    <div *ngIf="row['fdv-sla']">
                      SLA: {{ row['fdv-sla'] }}
                      <span *ngIf="row['fdv-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container *ngIf="layerToTest !== 'L4'">
                <td
                  *ngIf="
                    testMode === 'loopback' &&
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fd-avg']"
                    [ngClass]="{
                      'kpi-good': row['fd-verdict'] === 'pass',
                      'kpi-bad': row['fd-verdict'] === 'fail'
                    }"
                  >
                    Avg: {{ row['fd-avg'] }}
                    <span *ngIf="row['fd-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10">
                    <div *ngIf="row['fd-min']">
                      Min: {{ row['fd-min'] }} <span *ngIf="row['fd-min'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-max']">
                      Max: {{ row['fd-max'] }} <span *ngIf="row['fd-max'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-sla']">
                      SLA: {{ row['fd-sla'] }} <span *ngIf="row['fd-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
                <td
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fdv-avg']"
                    [ngClass]="{
                      'kpi-good':
                        row['fdv-verdict'] === 'pass' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10',
                      'kpi-bad':
                        row['fdv-verdict'] === 'fail' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10'
                    }"
                  >
                    Avg: {{ row['fdv-avg'] }}
                    <span *ngIf="row['fdv-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10" *ngIf="row['fdv-max']">
                    <div
                      [ngClass]="{
                        'kpi-good':
                          row['fdv-verdict'] === 'pass' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10',
                        'kpi-bad':
                          row['fdv-verdict'] === 'fail' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10'
                      }"
                    >
                      Max: {{ row['fdv-max'] }}
                      <span *ngIf="row['fdv-max'] !== 'n/a'">ms</span>
                    </div>
                    <div *ngIf="row['fdv-sla']">
                      SLA: {{ row['fdv-sla'] }}
                      <span *ngIf="row['fdv-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
              </ng-container>

              <td
                class="th-background-color"
                *ngIf="
                  row['tx-frame-count'] ||
                  row['rx-frame-count'] ||
                  row['frame-loss-count'] ||
                  row['oos-count']
                "
              >
                <div *ngIf="row['tx-frame-count']">Tx: {{ row['tx-frame-count'] }}</div>
                <div *ngIf="row['rx-frame-count']">Rx: {{ row['rx-frame-count'] }}</div>
                <div *ngIf="row['frame-loss-count']">Lost: {{ row['frame-loss-count'] }}</div>
                <div *ngIf="row['oos-count']">OOS: {{ row['oos-count'] }}</div>
              </td>
            </tr>
          </table>
        </div>
        <div *ngIf="trendChartsData" class="sct-metric-container">
          <div *ngFor="let series of chartSeriesConfig" class="sct-metrics">
            <div *ngFor="let stream of performanceData" class="field-style">
              <div *ngIf="row['stream-name'] === stream.name" class="sct-metric-section">
                <div *ngIf="row['originator'] === 'engine-a' || row['originator'] === 'ENGINE_A'">
                  <nrwl-stream-metrics-chart
                    [seriesOptions]="series"
                    [chartData]="stream.engineAData.dataSource"
                    [stepTime]="durationForStream"
                    [streamConfig]="stream.streamConfig"
                    [showCurrentValue]="false"
                  ></nrwl-stream-metrics-chart>
                </div>
                <div *ngIf="row['originator'] === 'engine-b' || row['originator'] === 'ENGINE_B'">
                  <nrwl-stream-metrics-chart
                    [seriesOptions]="series"
                    [chartData]="stream.engineBData.dataSource"
                    [stepTime]="durationForStream"
                    [streamConfig]="stream.streamConfig"
                    [showCurrentValue]="false"
                  ></nrwl-stream-metrics-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div layout="column" class="page" *ngIf="spAngReport && showCharts">
    <div class="page-break"></div>
    <div class="header-font-1">
      <div class="alignment-font">
        <img class="icon" [attr.src]="'images/SPTIcon.svg'" />
        <span class="margin-10-left">Service Performance Stream Comparisons</span>
      </div>
    </div>
    <div class="page-break"></div>
    <!-- Engine A Charts -->
    <ng-container *ngIf="engineACharts">
      <hr class="line-color" />
      <div class="direction1">A <i class="mdi mdi-arrow-right-bold onewayAColor"></i> B</div>
      <div class="t-charts-container">
        <ng-container
          *ngIf="engineACharts.irSeriesData && !hasInvalidData(engineACharts.irSeriesData)"
        >
          <nrwl-performance-stream-comparisons
            [chartType]="getStreamRateChartType()"
            [categories]="engineACharts.irCategories"
            [seriesData]="engineACharts.irSeriesData"
            [chartId]="'irChartA'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>

        <ng-container
          *ngIf="engineACharts.flSeriesData && !hasInvalidData(engineACharts.flSeriesData)"
        >
          <nrwl-performance-stream-comparisons
            [chartType]="'Loss'"
            [categories]="engineACharts.flCategories"
            [seriesData]="engineACharts.flSeriesData"
            [chartId]="'flChartA'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>

        <ng-container
          *ngIf="engineACharts.fdSeriesData && !hasInvalidData(engineACharts.fdSeriesData)"
        >
          <nrwl-performance-stream-comparisons
            [chartType]="'FD'"
            [categories]="engineACharts.fdCategories"
            [seriesData]="engineACharts.fdSeriesData"
            [chartId]="'fdChartA'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>

        <ng-container
          *ngIf="
            engineACharts.fdDistributionSeriesData &&
            !hasInvalidData(engineACharts.fdDistributionSeriesData)
          "
        >
          <nrwl-performance-stream-comparisons
            [chartType]="'FD Distribution'"
            [categories]="engineACharts.fdDistributionCategories"
            [seriesData]="engineACharts.fdDistributionSeriesData"
            [chartId]="'fdDistributionChartA'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>

        <ng-container
          *ngIf="engineACharts.fdvSeriesData && !hasInvalidData(engineACharts.fdvSeriesData)"
        >
          <nrwl-performance-stream-comparisons
            [chartType]="'FDV'"
            [categories]="engineACharts.fdvCategories"
            [seriesData]="engineACharts.fdvSeriesData"
            [chartId]="'fdvChartA'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>
      </div>
    </ng-container>

    <!-- Engine B Charts -->
    <ng-container *ngIf="engineBCharts">
      <!-- <hr class="line-color"/> -->
      <div class="direction1">B <i class="mdi mdi-arrow-right-bold onewayBColor"></i> A</div>
      <div class="t-charts-container">
        <ng-container
          *ngIf="engineBCharts.irSeriesData && !hasInvalidData(engineBCharts.irSeriesData)"
        >
          <nrwl-performance-stream-comparisons
            [chartType]="getStreamRateChartType()"
            [categories]="engineBCharts.irCategories"
            [seriesData]="engineBCharts.irSeriesData"
            [chartId]="'irChartB'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>

        <ng-container
          *ngIf="engineBCharts.flSeriesData && !hasInvalidData(engineBCharts.flSeriesData)"
        >
          <nrwl-performance-stream-comparisons
            [chartType]="'Loss'"
            [categories]="engineBCharts.flCategories"
            [seriesData]="engineBCharts.flSeriesData"
            [chartId]="'flChartB'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>

        <ng-container
          *ngIf="engineBCharts.fdSeriesData && !hasInvalidData(engineBCharts.fdSeriesData)"
        >
          <nrwl-performance-stream-comparisons
            [chartType]="'FD'"
            [categories]="engineBCharts.fdCategories"
            [seriesData]="engineBCharts.fdSeriesData"
            [chartId]="'fdChartB'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>

        <ng-container
          *ngIf="
            engineBCharts.fdDistributionSeriesData &&
            !hasInvalidData(engineBCharts.fdDistributionSeriesData)
          "
        >
          <nrwl-performance-stream-comparisons
            [chartType]="'FD Distribution'"
            [categories]="engineBCharts.fdDistributionCategories"
            [seriesData]="engineBCharts.fdDistributionSeriesData"
            [chartId]="'fdDistributionChartB'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>

        <ng-container
          *ngIf="engineBCharts.fdvSeriesData && !hasInvalidData(engineBCharts.fdvSeriesData)"
        >
          <nrwl-performance-stream-comparisons
            [chartType]="'FDV'"
            [categories]="engineBCharts.fdvCategories"
            [seriesData]="engineBCharts.fdvSeriesData"
            [chartId]="'fdvChartB'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>
      </div>
    </ng-container>

    <!-- Single Engine Charts (if no engine-b data) -->
    <ng-container *ngIf="singleEngineCharts">
      <div class="direction1" *ngIf="testMode !== 'loopback'">
        A <i class="mdi mdi-arrow-right-bold onewayAColor"></i> B
      </div>
      <div class="t-charts-container">
        <ng-container
          *ngIf="
            singleEngineCharts.irSeriesData && !hasInvalidData(singleEngineCharts.irSeriesData)
          "
        >
          <nrwl-performance-stream-comparisons
            [chartType]="getStreamRateChartType()"
            [categories]="singleEngineCharts.irCategories"
            [seriesData]="singleEngineCharts.irSeriesData"
            [chartId]="'irChart'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>

        <ng-container
          *ngIf="
            singleEngineCharts.flSeriesData && !hasInvalidData(singleEngineCharts.flSeriesData)
          "
        >
          <nrwl-performance-stream-comparisons
            [chartType]="'Loss'"
            [categories]="singleEngineCharts.flCategories"
            [seriesData]="singleEngineCharts.flSeriesData"
            [chartId]="'flChart'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>

        <ng-container
          *ngIf="
            singleEngineCharts.fdSeriesData && !hasInvalidData(singleEngineCharts.fdSeriesData)
          "
        >
          <nrwl-performance-stream-comparisons
            [chartType]="'FD'"
            [categories]="singleEngineCharts.fdCategories"
            [seriesData]="singleEngineCharts.fdSeriesData"
            [chartId]="'fdChart'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>

        <ng-container
          *ngIf="
            singleEngineCharts.fdDistributionSeriesData &&
            !hasInvalidData(singleEngineCharts.fdDistributionSeriesData)
          "
        >
          <nrwl-performance-stream-comparisons
            [chartType]="'FD Distribution'"
            [categories]="singleEngineCharts.fdDistributionCategories"
            [seriesData]="singleEngineCharts.fdDistributionSeriesData"
            [chartId]="'fdDistributionChart'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>

        <ng-container
          *ngIf="
            singleEngineCharts.fdvSeriesData && !hasInvalidData(singleEngineCharts.fdvSeriesData)
          "
        >
          <nrwl-performance-stream-comparisons
            [chartType]="'FDV'"
            [categories]="singleEngineCharts.fdvCategories"
            [seriesData]="singleEngineCharts.fdvSeriesData"
            [chartId]="'fdvChart'"
          ></nrwl-performance-stream-comparisons>
          <div class="page-break"></div>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <div layout="column" class="page" *ngIf="scAngReport">
    <div class="page-break"></div>
    <div class="header-font-2">
      <img class="icon" [attr.src]="'images/SCTIcon.svg'" />
      <span class="margin-10-left">Service Configuration Test Results</span>
    </div>
    <hr />

    <ng-container *ngIf="!showRtdOptions">
      <ng-container *ngFor="let row of sortScAngReport">
        <hr
          *ngIf="row['originator'] === 'engine-a' || row['originator'] === 'ENGINE_A'"
          class="line-color"
        />
        <div
          *ngIf="row['step-name'] !== 'eir' && row['step-name'] !== 'policing'"
          class="verdict-display"
        >
          <div *ngIf="row['verdict'] === 'pass'" class="pass-color-1">PASSED</div>
          <div *ngIf="row['verdict'] === 'fail'" class="fail-color-1">FAILED</div>
          <div class="stream-name">
            {{ row['stream-name'] }}
          </div>
          <div *ngIf="row['verdict'] === 'fail'" class="fail-color-2">
            {{ row['verdict-reason'] }}
          </div>
          <!-- <div class="direction" *ngIf="testMode !== 'loopback' && row['originator'] === 'engine-a' || row['originator'] === 'ENGINE_A'">A <i class="mdi mdi-arrow-right-bold onewayBColor"></i> B</div>
              <div class="direction" *ngIf="testMode !== 'loopback' && row['originator'] === 'engine-b' || row['originator'] === 'ENGINE_B'">A <i class="mdi mdi-arrow-left-bold onewayAColor"></i> B</div> -->
        </div>
        <div
          class="direction1"
          *ngIf="
            testMode !== 'loopback' &&
            (row['originator'] === 'engine-a' || row['originator'] === 'ENGINE_A')
          "
        >
          A <i class="mdi mdi-arrow-right-bold onewayAColor"></i> B
        </div>
        <div
          class="direction1"
          *ngIf="
            testMode !== 'loopback' &&
            (row['originator'] === 'engine-b' || row['originator'] === 'ENGINE_B')
          "
        >
          B <i class="mdi mdi-arrow-right-bold onewayBColor"></i> A
        </div>

        <div class="field-style">
          <div class="width-font">
            <div
              *ngIf="
                row['verdict'] === 'fail' &&
                row['step-name'] &&
                row['step-name'] !== 'cir' &&
                row['step-name'] !== 'eir' &&
                row['step-name'] !== 'policing'
              "
            >
              <div class="fail-step-font">Step CIR at {{ row['step-name'] }}</div>
            </div>
            <div *ngIf="row['verdict'] === 'fail' && row['step-name'] === 'cir'">
              <div class="fail-step-font">Step CIR at 100%</div>
            </div>
            <div
              *ngIf="
                row['step-name'] === 'cir' &&
                row['verdict'] === 'pass' &&
                row['step-name'] !== 'eir' &&
                row['step-name'] !== 'policing'
              "
            >
              <div class="step-color">Step CIR at 100%</div>
            </div>
            <div
              *ngIf="
                row['step-name'] !== 'cir' &&
                row['verdict'] === 'pass' &&
                row['step-name'] &&
                row['step-name'] !== 'eir' &&
                row['step-name'] !== 'policing'
              "
            >
              <div class="step-color">
                Step CIR at {{ row['step-name'] === 'cir' ? 100 : row['step-name'] }}%
              </div>
            </div>
            <div *ngIf="row['step-name'] === 'eir'">
              <div class="step-color">Step EIR</div>
            </div>
            <div *ngIf="row['step-name'] === 'policing' && row['verdict'] === 'pass'">
              <div class="step-color">Step Policing</div>
            </div>
            <div *ngIf="row['step-name'] === 'policing' && row['verdict'] === 'fail'">
              <div class="fail-step-font">Step Policing</div>
            </div>
            &nbsp; &nbsp;
            <div *ngIf="row['frame-size-average']" class="alignment-font">
              <div class="bold-font">Frame</div>
              <div>: {{ row['frame-size-average'] }}</div>
            </div>
            <div *ngIf="row['target-ir']" class="alignment-font">
              <div class="bold-font" *ngIf="streamRateValue === 'l1-mbps'">CIR (ULR)</div>
              <div class="bold-font" *ngIf="streamRateValue === 'l2-mbps'">CIR (IR)</div>
              <div>: {{ row['target-ir'] }} Mbps</div>
            </div>
            <div *ngIf="row['transmitted-ir']" class="alignment-font">
              <div class="bold-font">Tx IR</div>
              <div>: {{ row['transmitted-ir'] }} Mbps</div>
            </div>
            <div *ngIf="row['transmitted-ulr']" class="alignment-font">
              <div class="bold-font">Tx ULR</div>
              <div>:{{ row['transmitted-ulr'] }} Mbps</div>
            </div>
            <div *ngIf="row['network-ulr']" class="alignment-font">
              <div class="bold-font">Network ULR</div>
              <div>: {{ row['network-ulr'] }} Mbps</div>
            </div>
            <div
              *ngIf="streamRateConvention !== 'L1 Mbps (ULR)' && row['ir-avg']"
              class="alignment-font"
            >
              <div class="bold-font">IR Avg</div>
              <div>: {{ row['ir-avg'] }} Mbps</div>
            </div>
          </div>
          <table class="sp-table" style="width: 80%">
            <tr>
              <th
                class="header-top-color"
                *ngIf="streamRateConvention === 'L1 Mbps (ULR)' || row['network-ulr']"
              >
                L1 Mbps (ULR)
              </th>
              <th
                class="header-top-color"
                *ngIf="
                  streamRateConvention !== 'L1 Mbps (ULR)' &&
                  (row['ir-avg'] || row['ir-min'] || row['ir-max'])
                "
              >
                L2 Mbps (IR)
              </th>
              <th
                *ngIf="
                  row['flr-verdict'] &&
                  (row['frame-loss-ratio'] !== 'NaN' ||
                    row['frame-loss-ratio'] !== 'undefined' ||
                    row['peak-frame-loss-ratio'] ||
                    row['frame-loss-sla'])
                "
                [ngStyle]="
                  row['flr-verdict'] === 'fail'
                    ? { background: '#fae5ea' }
                    : { background: '#eaf5f6' }
                "
              >
                Loss
              </th>
              <ng-container *ngIf="testMode === 'loopback' && layerToTest === 'L4'">
                <th
                  *ngIf="
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FD
                </th>
                <th
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FDV
                </th>
              </ng-container>
              <ng-container *ngIf="layerToTest !== 'L4'">
                <th
                  *ngIf="
                    testMode === 'loopback' &&
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FD
                </th>
                <th
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FDV
                </th>
              </ng-container>

              <th
                class="th-background-color"
                *ngIf="
                  row['tx-frame-count'] ||
                  row['rx-frame-count'] ||
                  row['frame-loss-count'] ||
                  row['oos-count']
                "
              >
                Counts
              </th>
            </tr>
            <tr>
              <td *ngIf="streamRateConvention === 'L1 Mbps (ULR)' && !row['network-ulr']">
                <div class="bold-font" *ngIf="row['transmitted-ulr']">
                  Tx: {{ row['transmitted-ulr'] }}
                  <span class="normal-font">Mbps</span>
                </div>
                <div class="bold-font">
                  Rx: {{ row['ir-avg'] }}
                  <span class="normal-font">Mbps</span>
                </div>
              </td>
              <td *ngIf="row['network-ulr']">
                <div class="bold-font" *ngIf="row['transmitted-ulr']">
                  Tx: {{ row['transmitted-ulr'] }}
                  <span class="normal-font">Mbps</span>
                </div>
                <div class="bold-font">
                  Rx: {{ row['network-ulr'] }}
                  <span class="normal-font">Mbps</span>
                </div>
              </td>
              <td
                class="header-top-color"
                *ngIf="
                  streamRateConvention !== 'L1 Mbps (ULR)' &&
                  (row['ir-avg'] || row['ir-min'] || row['ir-max'])
                "
              >
                <div class="bold-font" *ngIf="row['transmitted-ir']">
                  Tx: {{ row['transmitted-ir'] }} <span class="normal-font">Mbps</span>
                </div>
                <div class="bold-font" *ngIf="row['ir-avg']">
                  Rx Avg: {{ row['ir-avg'] }} <span class="normal-font">Mbps</span>
                </div>
                <div class="margin-10">
                  <div *ngIf="row['ir-min']">Rx Min: {{ row['ir-min'] }} Mbps</div>
                  <div *ngIf="row['ir-max']">Rx Max: {{ row['ir-max'] }} Mbps</div>
                </div>
              </td>

              <td
                *ngIf="
                  row['flr-verdict'] &&
                  (row['frame-loss-ratio'] !== 'NaN' ||
                    row['frame-loss-ratio'] !== 'undefined' ||
                    row['peak-frame-loss-ratio'] ||
                    row['frame-loss-sla'])
                "
                [ngStyle]="
                  row['flr-verdict'] === 'fail'
                    ? { background: '#fae5ea' }
                    : { background: '#eaf5f6' }
                "
              >
                <div
                  class="bold-font"
                  *ngIf="
                    showRtdOptions &&
                    (row['frame-loss-ratio'] !== 'NaN' || row['frame-loss-ratio'] !== 'undefined')
                  "
                  [ngClass]="{
                    'kpi-bad': row['flr-verdict'] === 'fail'
                  }"
                >
                  Avg: {{ formatFLR(row['frame-loss-ratio']) }} <span class="normal-font">%</span>
                </div>
                <div
                  class="bold-font"
                  *ngIf="
                    !showRtdOptions &&
                    versionValue === 'v1' &&
                    (row['frame-loss-ratio'] !== 'NaN' || row['frame-loss-ratio'] !== 'undefined')
                  "
                  [ngClass]="{
                    'kpi-bad': row['flr-verdict'] === 'fail'
                  }"
                >
                  Avg: {{ formatFLR(row['frame-loss-ratio']) }}
                  <span class="normal-font">%</span>
                </div>
                <div
                  class="bold-font"
                  *ngIf="
                    !showRtdOptions &&
                    versionValue === 'v2' &&
                    (row['frame-loss-ratio'] !== 'NaN' || row['frame-loss-ratio'] !== 'undefined')
                  "
                  [ngClass]="{
                    'kpi-bad': row['flr-verdict'] === 'fail'
                  }"
                >
                  Avg: {{ formatFLR(row['frame-loss-ratio']) }}
                  <span class="normal-font">%</span>
                </div>
                <div class="margin-10">
                  <div *ngIf="row['peak-frame-loss-ratio']">
                    Peak: {{ row['peak-frame-loss-ratio'] }} %
                  </div>
                  <div *ngIf="row['frame-loss-sla']">SLA: {{ row['frame-loss-sla'] }} %</div>
                </div>
              </td>
              <ng-container *ngIf="testMode === 'loopback' && layerToTest === 'L4'">
                <td
                  *ngIf="
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fd-avg']"
                    [ngClass]="{
                      'kpi-good': row['fd-verdict'] === 'pass',
                      'kpi-bad': row['fd-verdict'] === 'fail'
                    }"
                  >
                    Avg: {{ row['fd-avg'] }}
                    <span *ngIf="row['fd-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10">
                    <div *ngIf="row['fd-min']">
                      Min: {{ row['fd-min'] }} <span *ngIf="row['fd-min'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-max']">
                      Max: {{ row['fd-max'] }} <span *ngIf="row['fd-max'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-sla']">
                      SLA: {{ row['fd-sla'] }} <span *ngIf="row['fd-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
                <td
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fdv-avg']"
                    [ngClass]="{
                      'kpi-good':
                        row['fdv-verdict'] === 'pass' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10',
                      'kpi-bad':
                        row['fdv-verdict'] === 'fail' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10'
                    }"
                  >
                    Avg: {{ row['fdv-avg'] }}
                    <span *ngIf="row['fdv-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10">
                    <div
                      *ngIf="row['fdv-max']"
                      [ngClass]="{
                        'kpi-good':
                          row['fdv-verdict'] === 'pass' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10',
                        'kpi-bad':
                          row['fdv-verdict'] === 'fail' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10'
                      }"
                    >
                      Max: {{ row['fdv-max'] }}
                      <span *ngIf="row['fdv-max'] !== 'n/a'">ms</span>
                    </div>
                    <div *ngIf="row['fdv-sla']">
                      SLA: {{ row['fdv-sla'] }}
                      <span *ngIf="row['fdv-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container *ngIf="layerToTest !== 'L4'">
                <td
                  *ngIf="
                    testMode === 'loopback' &&
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fd-avg']"
                    [ngClass]="{
                      'kpi-good': row['fd-verdict'] === 'pass',
                      'kpi-bad': row['fd-verdict'] === 'fail'
                    }"
                  >
                    Avg: {{ row['fd-avg'] }}
                    <span *ngIf="row['fd-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10">
                    <div *ngIf="row['fd-min']">
                      Min: {{ row['fd-min'] }} <span *ngIf="row['fd-min'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-max']">
                      Max: {{ row['fd-max'] }} <span *ngIf="row['fd-max'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-sla']">
                      SLA: {{ row['fd-sla'] }} <span *ngIf="row['fd-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
                <td
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fdv-avg']"
                    [ngClass]="{
                      'kpi-good':
                        row['fdv-verdict'] === 'pass' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10',
                      'kpi-bad':
                        row['fdv-verdict'] === 'fail' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10'
                    }"
                  >
                    Avg: {{ row['fdv-avg'] }}
                    <span *ngIf="row['fdv-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10">
                    <div
                      *ngIf="row['fdv-max']"
                      [ngClass]="{
                        'kpi-good':
                          row['fdv-verdict'] === 'pass' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10',
                        'kpi-bad':
                          row['fdv-verdict'] === 'fail' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10'
                      }"
                    >
                      Max: {{ row['fdv-max'] }}
                      <span *ngIf="row['fdv-max'] !== 'n/a'">ms</span>
                    </div>
                    <div *ngIf="row['fdv-sla']">
                      SLA: {{ row['fdv-sla'] }}
                      <span *ngIf="row['fdv-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
              </ng-container>

              <td
                class="th-background-color"
                *ngIf="
                  row['tx-frame-count'] ||
                  row['rx-frame-count'] ||
                  row['frame-loss-count'] ||
                  row['oos-count']
                "
              >
                <div *ngIf="row['tx-frame-count']">Tx: {{ row['tx-frame-count'] }}</div>
                <div *ngIf="row['rx-frame-count']">Rx: {{ row['rx-frame-count'] }}</div>
                <div *ngIf="row['frame-loss-count']">Lost: {{ row['frame-loss-count'] }}</div>
                <div *ngIf="row['oos-count']">OOS: {{ row['oos-count'] }}</div>
              </td>
            </tr>
          </table>
        </div>
        <!-- <hr *ngIf="row['step-name'] != 'eir'" class="line-color" /> -->
      </ng-container>
    </ng-container>

    <ng-container *ngIf="showRtdOptions">
      <ng-container *ngFor="let row of uniqueScArray">
        <hr
          *ngIf="row['step-name'] !== 'eir' && row['step-name'] !== 'policing'"
          class="line-color"
        />
        <div
          *ngIf="row['step-name'] !== 'eir' && row['step-name'] !== 'policing'"
          class="verdict-display"
        >
          <div *ngIf="row['verdict'] === 'pass'" class="pass-color-1">PASSED</div>
          <div *ngIf="row['verdict'] === 'fail'" class="fail-color-1">FAILED</div>
          <div class="stream-name">
            {{ row['stream-name'] }}
          </div>
          <div *ngIf="row['verdict'] === 'fail'" class="fail-color-2">
            {{ row['verdict-reason'] }}
          </div>
          <div *ngIf="row['verdict'] === 'pass'" class="pass-color-2">
            {{ row['verdict-reason'] }}
          </div>
        </div>

        <div class="field-style">
          <div class="width-font">
            <div
              *ngIf="
                row['verdict'] === 'fail' &&
                row['step-name'] &&
                row['step-name'] !== 'cir' &&
                row['step-name'] !== 'eir' &&
                row['step-name'] !== 'policing'
              "
            >
              <div class="fail-step-font">Step CIR at {{ row['step-name'] }}</div>
            </div>
            <div *ngIf="row['verdict'] === 'fail' && row['step-name'] === 'cir'">
              <div class="fail-step-font">Step CIR at 100%</div>
            </div>
            <div
              *ngIf="
                row['verdict'] === 'pass' &&
                row['step-name'] !== 'eir' &&
                row['step-name'] !== 'policing'
              "
            >
              <div class="step-color">Step CIR at 100%</div>
            </div>
            <div *ngIf="row['step-name'] === 'eir'">
              <div class="step-color">Step EIR</div>
            </div>
            <div *ngIf="row['step-name'] === 'policing' && row['verdict'] === 'pass'">
              <div class="step-color">Step Policing</div>
            </div>
            <div *ngIf="row['step-name'] === 'policing' && row['verdict'] === 'fail'">
              <div class="fail-step-font">Step Policing</div>
            </div>
            &nbsp; &nbsp;
            <div *ngIf="row['frame-size-average']" class="alignment-font">
              <div class="bold-font">Frame</div>
              <div>: {{ row['frame-size-average'] }}</div>
            </div>
            <div *ngIf="row['target-ir']" class="alignment-font">
              <div class="bold-font" *ngIf="streamRateValue === 'l1-mbps'">CIR (ULR)</div>
              <div class="bold-font" *ngIf="streamRateValue === 'l2-mbps'">CIR (IR)</div>
              <div>: {{ row['target-ir'] }} Mbps</div>
            </div>
            <div *ngIf="row['transmitted-ir']" class="alignment-font">
              <div class="bold-font">Tx IR</div>
              <div>: {{ row['transmitted-ir'] }} Mbps</div>
            </div>
            <div *ngIf="row['transmitted-ulr']" class="alignment-font">
              <div class="bold-font">Tx ULR</div>
              <div>:{{ row['transmitted-ulr'] }} Mbps</div>
            </div>
            <div *ngIf="row['network-ulr']" class="alignment-font">
              <div class="bold-font">Network ULR</div>
              <div>: {{ row['network-ulr'] }} Mbps</div>
            </div>
          </div>
          <table class="sp-table" style="width: 80%">
            <tr>
              <th
                class="header-top-color"
                *ngIf="streamRateConvention === 'L1 Mbps (ULR)' || row['network-ulr']"
              >
                L1 Mbps (ULR)
              </th>
              <th
                class="header-top-color"
                *ngIf="
                  streamRateConvention !== 'L1 Mbps (ULR)' &&
                  (row['ir-avg'] || row['ir-min'] || row['ir-max'])
                "
              >
                L2 Mbps (IR)
              </th>
              <th
                *ngIf="
                  row['flr-verdict'] &&
                  (row['frame-loss-ratio'] !== 'NaN' ||
                    row['frame-loss-ratio'] !== 'undefined' ||
                    row['peak-frame-loss-ratio'] ||
                    row['frame-loss-sla'])
                "
                [ngStyle]="
                  row['flr-verdict'] === 'fail'
                    ? { background: '#fae5ea' }
                    : { background: '#eaf5f6' }
                "
              >
                Loss
              </th>
              <ng-container *ngIf="testMode === 'loopback' && layerToTest === 'L4'">
                <th
                  *ngIf="
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FD
                </th>
                <th
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FDV
                </th>
              </ng-container>
              <ng-container *ngIf="layerToTest !== 'L4'">
                <th
                  *ngIf="
                    testMode === 'loopback' &&
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FD
                </th>
                <th
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  FDV
                </th>
              </ng-container>

              <th
                class="th-background-color"
                *ngIf="
                  row['tx-frame-count'] ||
                  row['rx-frame-count'] ||
                  row['frame-loss-count'] ||
                  row['oos-count']
                "
              >
                Counts
              </th>
            </tr>
            <tr>
              <td *ngIf="streamRateConvention === 'L1 Mbps (ULR)' && !row['network-ulr']">
                <div class="bold-font" *ngIf="row['transmitted-ulr']">
                  Tx: {{ row['transmitted-ulr'] }}
                  <span class="normal-font">Mbps</span>
                </div>
                <div class="bold-font">
                  Rx: {{ row['ir-avg'] }}
                  <span class="normal-font">Mbps</span>
                </div>
              </td>
              <td *ngIf="row['network-ulr']">
                <div class="bold-font" *ngIf="row['transmitted-ulr']">
                  Tx: {{ row['transmitted-ulr'] }}
                  <span class="normal-font">Mbps</span>
                </div>
                <div class="bold-font">
                  Rx: {{ row['network-ulr'] }}
                  <span class="normal-font">Mbps</span>
                </div>
              </td>
              <td
                class="header-top-color"
                *ngIf="
                  streamRateConvention !== 'L1 Mbps (ULR)' &&
                  (row['ir-avg'] || row['ir-min'] || row['ir-max'])
                "
              >
                <div class="bold-font" *ngIf="row['transmitted-ir']">
                  Tx: {{ row['transmitted-ir'] }} <span class="normal-font">Mbps</span>
                </div>
                <div class="bold-font" *ngIf="row['ir-avg']">
                  Rx Avg: {{ row['ir-avg'] }} <span class="normal-font">Mbps</span>
                </div>
                <div class="margin-10">
                  <div *ngIf="row['ir-min']">Rx Min: {{ row['ir-min'] }} Mbps</div>
                  <div *ngIf="row['ir-max']">Rx Max: {{ row['ir-max'] }} Mbps</div>
                </div>
              </td>

              <td
                *ngIf="
                  row['flr-verdict'] &&
                  (row['frame-loss-ratio'] !== 'NaN' ||
                    row['frame-loss-ratio'] !== 'undefined' ||
                    row['peak-frame-loss-ratio'] ||
                    row['frame-loss-sla'])
                "
                [ngStyle]="
                  row['flr-verdict'] === 'fail'
                    ? { background: '#fae5ea' }
                    : { background: '#eaf5f6' }
                "
              >
                <div
                  class="bold-font"
                  *ngIf="
                    row['frame-loss-ratio'] !== 'NaN' || row['frame-loss-ratio'] !== 'undefined'
                  "
                  [ngClass]="{
                    'kpi-bad': row['flr-verdict'] === 'fail'
                  }"
                >
                  Avg: {{ formatFLR(row['frame-loss-ratio']) }} <span class="normal-font">%</span>
                </div>
                <div class="margin-10">
                  <div *ngIf="row['peak-frame-loss-ratio']">
                    Peak: {{ row['peak-frame-loss-ratio'] }} %
                  </div>
                  <div *ngIf="row['frame-loss-sla']">SLA: {{ row['frame-loss-sla'] }} %</div>
                </div>
              </td>
              <ng-container *ngIf="testMode === 'loopback' && layerToTest === 'L4'">
                <td
                  *ngIf="
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fd-avg']"
                    [ngClass]="{
                      'kpi-good': row['fd-verdict'] === 'pass',
                      'kpi-bad': row['fd-verdict'] === 'fail'
                    }"
                  >
                    Avg: {{ row['fd-avg'] }}
                    <span *ngIf="row['fd-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10">
                    <div *ngIf="row['fd-min']">
                      Min: {{ row['fd-min'] }} <span *ngIf="row['fd-min'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-max']">
                      Max: {{ row['fd-max'] }} <span *ngIf="row['fd-max'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-sla']">
                      SLA: {{ row['fd-sla'] }} <span *ngIf="row['fd-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
                <td
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fdv-avg']"
                    [ngClass]="{
                      'kpi-good':
                        row['fdv-verdict'] === 'pass' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10',
                      'kpi-bad':
                        row['fdv-verdict'] === 'fail' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10'
                    }"
                  >
                    Avg: {{ row['fdv-avg'] }}
                    <span *ngIf="row['fdv-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10">
                    <div
                      *ngIf="row['fdv-max']"
                      [ngClass]="{
                        'kpi-good':
                          row['fdv-verdict'] === 'pass' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10',
                        'kpi-bad':
                          row['fdv-verdict'] === 'fail' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10'
                      }"
                    >
                      Max: {{ row['fdv-max'] }}
                      <span *ngIf="row['fdv-max'] !== 'n/a'">ms</span>
                    </div>
                    <div *ngIf="row['fdv-sla']">
                      SLA: {{ row['fdv-sla'] }}
                      <span *ngIf="row['fdv-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container *ngIf="layerToTest !== 'L4'">
                <td
                  *ngIf="
                    testMode === 'loopback' &&
                    row['fd-verdict'] &&
                    (row['fd-avg'] || row['fd-min'] || row['fd-max'] || row['fd-sla'])
                  "
                  [ngStyle]="
                    row['fd-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fd-avg']"
                    [ngClass]="{
                      'kpi-good': row['fd-verdict'] === 'pass',
                      'kpi-bad': row['fd-verdict'] === 'fail'
                    }"
                  >
                    Avg: {{ row['fd-avg'] }}
                    <span *ngIf="row['fd-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10">
                    <div *ngIf="row['fd-min']">
                      Min: {{ row['fd-min'] }} <span *ngIf="row['fd-min'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-max']">
                      Max: {{ row['fd-max'] }} <span *ngIf="row['fd-max'] !== 'n/a'">ms </span>
                    </div>
                    <div *ngIf="row['fd-sla']">
                      SLA: {{ row['fd-sla'] }} <span *ngIf="row['fd-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
                <td
                  *ngIf="row['fdv-verdict'] && (row['fdv-avg'] || row['fdv-max'] || row['fdv-sla'])"
                  [ngStyle]="
                    row['fdv-verdict'] === 'fail'
                      ? { background: '#fae5ea' }
                      : { background: '#eaf5f6' }
                  "
                >
                  <div
                    class="bold-font"
                    *ngIf="row['fdv-avg']"
                    [ngClass]="{
                      'kpi-good':
                        row['fdv-verdict'] === 'pass' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10',
                      'kpi-bad':
                        row['fdv-verdict'] === 'fail' &&
                        uiConfig?.testPoints[0]?.model === 'QT600-10'
                    }"
                  >
                    Avg: {{ row['fdv-avg'] }}
                    <span *ngIf="row['fdv-avg'] !== 'n/a'" class="normal-font">ms</span>
                  </div>
                  <div class="margin-10">
                    <div
                      *ngIf="row['fdv-max']"
                      [ngClass]="{
                        'kpi-good':
                          row['fdv-verdict'] === 'pass' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10',
                        'kpi-bad':
                          row['fdv-verdict'] === 'fail' &&
                          uiConfig?.testPoints[0]?.model !== 'QT600-10'
                      }"
                    >
                      Max: {{ row['fdv-max'] }}
                      <span *ngIf="row['fdv-max'] !== 'n/a'">ms</span>
                    </div>
                    <div *ngIf="row['fdv-sla']">
                      SLA: {{ row['fdv-sla'] }}
                      <span *ngIf="row['fdv-sla'] !== 'n/a'">ms </span>
                    </div>
                  </div>
                </td>
              </ng-container>

              <td
                class="th-background-color"
                *ngIf="
                  row['tx-frame-count'] ||
                  row['rx-frame-count'] ||
                  row['frame-loss-count'] ||
                  row['oos-count']
                "
              >
                <div *ngIf="row['tx-frame-count']">Tx: {{ row['tx-frame-count'] }}</div>
                <div *ngIf="row['rx-frame-count']">Rx: {{ row['rx-frame-count'] }}</div>
                <div *ngIf="row['frame-loss-count']">Lost: {{ row['frame-loss-count'] }}</div>
                <div *ngIf="row['oos-count']">OOS: {{ row['oos-count'] }}</div>
              </td>
            </tr>
          </table>
        </div>
        <!-- <hr *ngIf="row['step-name'] != 'eir'" class="line-color" /> -->
      </ng-container>
    </ng-container>
  </div>
  <div layout="column" class="page">
    <div class="page-break"></div>
    <div class="header-font-2">
      <i class="material-icons icon">settings</i>
      <span class="margin-10-left">Test Configuration</span>
    </div>
    <hr />
    <div class="test-margin">
      <div class="test-font">Test Setup</div>
      <table
        style="width: 70%; border-left: unset; border-right: unset; font-size: 14px"
        class="test-setup-table"
      >
        <tr>
          <td class="test-color">Test Mode</td>
          <td>{{ testType }}</td>
        </tr>
        <tr>
          <td class="test-color">Layer to Test</td>
          <td>{{ layer }}</td>
        </tr>
        <tr>
          <td class="test-color">Stream rate Convention</td>
          <td>{{ streamRateConvention }}</td>
        </tr>
        <tr>
          <td class="test-color">IP Address Type</td>
          <td>{{ ipAddressType }}</td>
        </tr>

        <!-- Service Configuration Section -->
        <ng-container *ngIf="scAngReport">
          <tr>
            <td class="test-bold-color">Service Configuration</td>
            <td></td>
          </tr>
          <tr>
            <td class="test-color">Steps</td>
            <td>{{ stepPercents ? stepPercents + ' -100%' : '100%' }}</td>
          </tr>
          <tr>
            <td class="test-color">Step Duration</td>
            <td>{{ sctStepTime }} sec</td>
          </tr>
        </ng-container>

        <!-- Service Performance Section -->
        <ng-container *ngIf="spAngReport">
          <tr>
            <td class="test-bold-color">Service Performance</td>
            <td></td>
          </tr>
          <tr>
            <td class="test-color">Duration</td>
            <td>{{ duration }}</td>
          </tr>
          <tr
            *ngIf="
              y1564TestConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][0]['l2-config'][
                'vlan-id'
              ]
            "
          >
            <td class="test-color">S-VLAN</td>
            <td>
              {{
                y1564TestConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][0][
                  'l2-config'
                ]['vlan-id']
              }}
            </td>
          </tr>
          <tr
            *ngIf="
              y1564TestConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][0]['l2-config'][
                'inner-vlan-id'
              ]
            "
          >
            <td class="test-color">C-VLAN</td>
            <td>
              {{
                y1564TestConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][0][
                  'l2-config'
                ]['inner-vlan-id']
              }}
            </td>
          </tr>
          <tr
            *ngIf="
              y1564TestConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][0]['l2-config'][
                'ether-type'
              ]
            "
          >
            <td class="test-color">Ether Type</td>
            <td>
              {{
                y1564TestConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][0][
                  'l2-config'
                ]['ether-type']
              }}
            </td>
          </tr>
          <tr
            *ngIf="
              y1564TestConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][0]['l2-config'][
                'remote-tag-count'
              ]
            "
          >
            <td class="test-color">Remote VLAN Tag Count</td>
            <td>
              {{
                y1564TestConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][0][
                  'l2-config'
                ]['remote-tag-count']
              }}
            </td>
          </tr>
        </ng-container>
      </table>
    </div>

    <div class="test-margin">
      <div class="test-font">Endpoints</div>
      <div style="width: 70%">
        <table
          style="border-left: unset; border-right: unset; font-size: 14px; width: 100%"
          class="test-setup-table"
        >
          <tr>
            <td class="test-bold-color">
              <span *ngIf="!y1564TestConfig['viavi-solutions-y1564:y1564']['engine-b-info']"
                >Originator</span
              ><span *ngIf="y1564TestConfig['viavi-solutions-y1564:y1564']['engine-b-info']"
                >Test Point A</span
              >
            </td>
            <td></td>
          </tr>
          <tr>
            <td class="test-color">Name</td>
            <td>{{ overallConfiguration.agent.primary.id }}</td>
          </tr>
          <tr *ngIf="testConfigDisplay.tpaVersion">
            <td class="test-color">Version</td>
            <td>{{ testConfigDisplay.tpaVersion }}</td>
          </tr>
          <tr>
            <td class="test-color">Agent Type</td>
            <td>
              {{ y1564TestConfig['viavi-solutions-y1564:y1564']['engine-a-info']['engine-type'] }}
            </td>
          </tr>
          <tr
            *ngIf="
              y1564TestConfig['viavi-solutions-y1564:y1564']['engine-a-info'].address && isJmep
            "
          >
            <td class="test-color">ESAM IP Address</td>
            <td>
              {{ y1564TestConfig['viavi-solutions-y1564:y1564']['engine-a-info'].address }}
            </td>
          </tr>
          <tr
            *ngIf="
              y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters']['tx-interface']
            "
          >
            <td class="test-color">MAC Address</td>
            <td
              *ngIf="
                y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters'][
                  'tx-interface'
                ] === 'equipment'
              "
            >
              {{ equipmentMacAddress }}
            </td>
            <td
              *ngIf="
                y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters'][
                  'tx-interface'
                ] === 'network'
              "
            >
              {{ networkMacAddress }}
            </td>
          </tr>
          <tr
            *ngIf="
              y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters']['tx-interface']
            "
          >
            <td class="test-color">Transmit Interface</td>
            <td>
              {{
                y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters']['tx-interface']
              }}
            </td>
          </tr>
          <tr *ngIf="originMngmtIpAddress && !isJmep">
            <td class="test-color">Management Address</td>
            <td>
              {{ originMngmtIpAddress }}
            </td>
          </tr>
          <tr>
            <td class="test-color">Management Port</td>
            <td>{{ y1564TestConfig['viavi-solutions-y1564:y1564']['engine-a-info'].port }}</td>
          </tr>

          <tr
            *ngIf="
              layerToTest === '3' &&
              y1564TestConfig['viavi-solutions-y1564:y1564']['engine-a-info']['test-ip']
            "
          >
            <td class="test-color">Test Address</td>
            <td>
              {{ y1564TestConfig['viavi-solutions-y1564:y1564']['engine-a-info']['test-ip'] }}
            </td>
          </tr>
          <tr *ngIf="layerToTest === '3'">
            <td class="test-color">Test Subnet Mask</td>
            <td>
              {{
                y1564TestConfig['viavi-solutions-y1564:y1564']['engine-a-info']['test-subnet-mask']
              }}
            </td>
          </tr>
          <tr *ngIf="layerToTest === '3'">
            <td class="test-color">Test Gateway</td>
            <td>
              {{ y1564TestConfig['viavi-solutions-y1564:y1564']['engine-a-info']['test-gateway'] }}
            </td>
          </tr>
        </table>
        <table
          *ngIf="y1564TestConfig['viavi-solutions-y1564:y1564']['engine-b-info']"
          style="
            border-left: unset;
            border-right: unset;
            margin-top: 20px;
            font-size: 14px;
            width: 100%;
          "
          class="test-setup-table"
        >
          <tr>
            <td class="test-bold-color">Test Point B</td>
            <td></td>
          </tr>
          <tr>
            <td class="test-color">Name</td>
            <td>{{ overallConfiguration.agent.secondary[0].id }}</td>
          </tr>
          <tr *ngIf="testConfigDisplay.tpbVersion">
            <td class="test-color">Version</td>
            <td>{{ testConfigDisplay.tpbVersion }}</td>
          </tr>
          <tr>
            <td class="test-color">Agent Type</td>
            <td>
              {{ y1564TestConfig['viavi-solutions-y1564:y1564']['engine-b-info']['engine-type'] }}
            </td>
          </tr>
          <tr *ngIf="destinationMngmtIpAddress && !isJmep">
            <td class="test-color">Management Address</td>
            <td>
              {{ destinationMngmtIpAddress }}
            </td>
          </tr>
          <tr>
            <td class="test-color">Management Port</td>
            <td>{{ y1564TestConfig['viavi-solutions-y1564:y1564']['engine-b-info'].port }}</td>
          </tr>

          <tr
            *ngIf="
              layerToTest === '3' &&
              y1564TestConfig['viavi-solutions-y1564:y1564']['engine-b-info']['test-ip']
            "
          >
            <td class="test-color">Test Address</td>
            <td>
              {{ y1564TestConfig['viavi-solutions-y1564:y1564']['engine-b-info']['test-ip'] }}
            </td>
          </tr>
          <tr *ngIf="layerToTest === '3'">
            <td class="test-color">Test Subnet Mask</td>
            <td>
              {{
                y1564TestConfig['viavi-solutions-y1564:y1564']['engine-b-info']['test-subnet-mask']
              }}
            </td>
          </tr>
          <tr *ngIf="layerToTest === '3'">
            <td class="test-color">Test Gateway</td>
            <td>
              {{ y1564TestConfig['viavi-solutions-y1564:y1564']['engine-b-info']['test-gateway'] }}
            </td>
          </tr>
        </table>
        <table
          *ngIf="
            !y1564TestConfig['viavi-solutions-y1564:y1564']['engine-b-info'] &&
            (testMode === 'loopback' || testMode === 'Loopback')
          "
          style="
            border-left: unset;
            border-right: unset;
            font-size: 14px;
            margin-top: 20px;
            width: 100%;
          "
          class="test-setup-table"
        >
          <tr>
            <td class="test-bold-color">Destination</td>
            <td></td>
          </tr>
          <ng-container *ngFor="let attr of testConfigDisplay.destination">
            <tr>
              <td class="test-color">{{ attr.name }}</td>
              <td>{{ attr.value }}</td>
            </tr>
          </ng-container>
          <tr>
            <td class="test-color">Loopup Device</td>
            <td>
              {{ getLoopUpValue() }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <div layout="column" class="page">
    <div class="page-break"></div>
    <div style="font-size: 14px; font-weight: bold; display: flex; align-items: center">
      <i class="material-icons icon">settings</i>
      <span class="margin-10-left">Test Configuration</span>
    </div>
    <hr />
    <div class="test-margin" *ngFor="let stream of testConfigDisplay.streams; let i = index">
      <div class="test-font">Streams</div>
      <div style="width: 70%">
        <table
          style="width: 100%; border-left: unset; border-right: unset; font-size: 14px"
          class="test-setup-table"
        >
          <tr>
            <td class="test-bold-color">{{ stream.name }}</td>
            <td></td>
          </tr>
          <tr>
            <td class="test-color">Name</td>
            <td>{{ stream.name }}</td>
          </tr>
          <tr *ngIf="stream['toSDiffServValue']">
            <td class="test-color">DSCP</td>
            <td>{{ stream['toSDiffServValue'] }}</td>
          </tr>
          <ng-container *ngIf="testMode !== 'engine-b-to-engine-a'">
            <tr>
              <td
                class="direction1"
                *ngIf="testMode !== 'loopback' && testMode !== 'engine-b-to-engine-a'"
              >
                A <i class="mdi mdi-arrow-right-bold onewayAColor"></i> B
              </td>
            </tr>
            <tr>
              <td class="test-color">CIR</td>
              <td>{{ stream['cir-from-engine-a'] }} Mbps</td>
            </tr>
            <tr *ngIf="scEnabled === true">
              <td class="test-color">EIR</td>
              <td *ngIf="stream['eir-from-engine-a']">{{ stream['eir-from-engine-a'] }} Mbps</td>
              <td *ngIf="!stream['eir-from-engine-a']">0 Mbps</td>
            </tr>
            <tr *ngIf="scEnabled === true">
              <td class="test-color">Policing</td>
              <td>{{ stream['run-policing-from-engine-a'] }}</td>
            </tr>
            <tr *ngIf="scEnabled === true && stream['run-policing-from-engine-a'] === 'Yes'">
              <td class="test-color">Excess Allowed</td>
              <td>{{ stream['max-ir-from-engine-a'] }} Mbps</td>
            </tr>
            <ng-container *ngIf="stream['cbs-size'] > 0 && scEnabled">
              <tr>
                <td class="test-color">CBS size</td>
                <td>{{ stream['cbs-size'] }} KB</td>
              </tr>
              <tr>
                <td class="test-color">KiloByte Size</td>
                <td>{{ stream['cbs-kilo-size'] }}</td>
              </tr>
              <tr>
                <td class="test-color">Repetitions</td>
                <td>{{ stream['cbs-number-of-reps'] }}</td>
              </tr>
              <tr>
                <td class="test-color">Access Rate</td>
                <td>{{ stream['cbs-remote-line-rate'] }}</td>
              </tr>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="testMode !== 'loopback' && testMode !== 'unidirectional'">
            <tr>
              <td
                class="direction1"
                *ngIf="testMode !== 'loopback' && testMode !== 'unidirectional'"
              >
                B <i class="mdi mdi-arrow-right-bold onewayBColor"></i> A
              </td>
            </tr>
            <tr>
              <td class="test-color">CIR</td>
              <td *ngIf="stream['cir-from-engine-b']">{{ stream['cir-from-engine-b'] }} Mbps</td>
              <td *ngIf="!stream['cir-from-engine-b']">0 Mbps</td>
            </tr>
            <tr *ngIf="scEnabled === true">
              <td class="test-color">EIR</td>
              <td *ngIf="stream['eir-from-engine-b']">{{ stream['eir-from-engine-b'] }} Mbps</td>
              <td *ngIf="!stream['eir-from-engine-b']">0 Mbps</td>
            </tr>
            <tr *ngIf="scEnabled === true">
              <td class="test-color">Policing</td>
              <td>{{ stream['run-policing-from-engine-b'] }}</td>
            </tr>
            <tr *ngIf="scEnabled === true && stream['run-policing-from-engine-b'] === 'Yes'">
              <td class="test-color">Excess Allowed</td>
              <td>{{ stream['max-ir-from-engine-b'] }} Mbps</td>
            </tr>
          </ng-container>
          <tr>
            <td *ngIf="testMode !== 'loopback' && testMode !== 'unidirectional'"></td>
          </tr>
          <tr>
            <td class="test-color">Frame Loss</td>
            <td>{{ stream['frame-loss-ratio-threshold'] }}%</td>
          </tr>
          <tr *ngIf="testMode === 'loopback' || testMode === 'Loopback'">
            <td class="test-color">FD</td>
            <td>{{ stream['frame-delay-threshold'] }} ms</td>
          </tr>
          <tr *ngIf="stream['latency-FDV-maximum']">
            <td class="test-color">FDV</td>
            <td>{{ stream['latency-FDV-maximum'] }} ms</td>
          </tr>
          <tr *ngIf="stream['filter-on-tos']">
            <td class="test-color">Verify DSCP/TOS</td>
            <td>{{ stream['filter-on-tos'] }}</td>
          </tr>
          <tr *ngIf="stream['emix-Frame']">
            <td class="test-color">EMIX</td>
            <td>{{ stream['emix-Frame'] }}</td>
          </tr>
          <tr *ngIf="stream['vlan-priority'] >= 0">
            <td class="test-color">S-VLAN Priority</td>
            <td>Priority {{ stream['vlan-priority'] }}</td>
          </tr>
          <tr *ngIf="stream['inner-vlan-priority'] >= 0">
            <td class="test-color">C-VLAN Priority</td>
            <td>Priority {{ stream['inner-vlan-priority'] }}</td>
          </tr>

          <tr>
            <td class="test-color" *ngIf="scAngReport || spAngReport">
              <div>
                <div>
                  Frame Size
                  <div *ngIf="scAngReport">Service Configuration</div>
                  <div *ngIf="spAngReport">Service Performance</div>
                </div>
              </div>
            </td>
            <td *ngIf="scAngReport || spAngReport">
              <span *ngIf="scAngReport">
                {{ stream['sct-frame-length'] || stream['frame-length'] }}
              </span>
              <div *ngIf="spAngReport">
                {{ stream['spt-frame-length'] || stream['frame-length'] }}
              </div>
            </td>
          </tr>
          <ng-container>
            <!-- Display VLAN Tagging -->
            <tr *ngIf="stream['vlan-tagging']">
              <td class="test-color">Tagging</td>
              <td>{{ stream['vlan-tagging'] }}</td>
            </tr>

            <!-- Display VLAN ID and Priority for Tagged VLAN -->
            <tr *ngIf="stream?.['vlan-tagging'] === 'tagged'">
              <td class="test-color">VLAN ID:Priority</td>
              <td>{{ stream['svlan-id'] }}:{{ stream['svlan-priority'] }}</td>
            </tr>

            <!-- Display S-VLAN details for QINQ -->
            <ng-container *ngIf="stream?.['vlan-tagging'] === 'QINQ'">
              <tr>
                <td class="test-color">S-VLAN ID:Pri:TPID:Dei</td>
                <td>
                  {{ stream['svlan-id'] }}:{{ stream['svlan-priority'] }}:
                  {{ stream['svlan-tpid'] }}:{{ stream['svlan-deiEnabled'] }}
                </td>
              </tr>
              <!-- Display C-VLAN details for QINQ -->
              <tr>
                <td class="test-color">C-VLAN ID:Priority</td>
                <td>{{ stream['cvlan-id'] }}:{{ stream['cvlan-priority'] }}</td>
              </tr>
            </ng-container>
          </ng-container>

          <tr *ngIf="stream['ttl']">
            <td class="test-color">TTL</td>
            <td>{{ stream['ttl'] }}</td>
          </tr>
          <tr *ngIf="stream['payload'] && !isJmep && !isQT">
            <td class="test-color">Payload Type</td>
            <td>{{ stream['payload'] }}</td>
          </tr>
          <tr *ngIf="stream['traffic-class']">
            <td class="test-color">Traffic Class</td>
            <td>{{ stream['traffic-class'] }}</td>
          </tr>
          <tr *ngIf="stream['hop-limit']">
            <td class="test-color">Hop Limit</td>
            <td>{{ stream['hop-limit'] }}</td>
          </tr>
          <tr *ngIf="stream['spt-emix-Frame']">
            <td class="test-color">SPT EMIX</td>
            <td>{{ stream['spt-emix-Frame'] }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div
    fxLayout="column"
    class="page"
    fxLayoutGap="16px"
    *ngIf="reportmessage && reportmessage?.length !== 0"
  >
    <div class="page-break"></div>

    <mat-toolbar class="diagnosis-head border">
      <div class="mat-toolbar-tools">
        <h2 class="mat-flex">Report Message</h2>
      </div>
    </mat-toolbar>

    <mat-card class="border" fxLayout="column" fxLayoutGap="16px">
      <div fxLayout="row">
        <span>{{ reportmessage }}</span>
      </div>
    </mat-card>
  </div>
</div>
<div class="truespeed-content">
  <div class="loader-content" *ngIf="loading">
    <div class="spinner">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <div class="loader-text">
      <div class="text-message">Getting Reports</div>
    </div>
  </div>
</div>
